import { useEffect, React } from "react";
import { NavLink, useNavigate } from "react-router-dom"

import OrdersTable from "../../Components/MyOrders";


import { useAuthContext } from "../../Hooks/useAuthContext";


import RecentOrderStats from "./Components/RecentOrderStats";
import OrdersByMonthGraph from "./Components/OrdersByMonthGraph";
import SalesByRep from "./Components/SalesByRep";


import UFASLogo from '../../Assets/Images/UFAS.png';

import { jwtDecode } from 'jwt-decode';



export default function Home() {

    const { dispatch, user } = useAuthContext();
    console.log("current user:", user);
    const navigate = useNavigate();

    useEffect(() => {
        if (user.token) {
            if (isTokenExpired(user.token)) {
                localStorage.removeItem('user');
                //router.push('/login');
                dispatch({ type: "LOGOUT" })
                navigate("../")
            } else {
                //setUser(JSON.parse(localStorage.getItem('user')));
            }
        } else {
            dispatch({ type: "LOGOUT" })
            navigate("../")
        }
    }, []);



    const isTokenExpired = (token) => {
        if (!token) return true;
        try {
            const decodedToken = jwtDecode(token);
            const currentTime = Date.now() / 1000;
            return decodedToken.exp < currentTime;
        } catch (error) {
            console.error('Error decoding token:', error);
            return true;
        }
    };


    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    <h2>Home</h2>

                    {user && (user.role === "Admin" || user.role === "Director") && (
                        <div>
                            <OrdersByMonthGraph />
                            <RecentOrderStats />
                        </div>
                    )}

                    <div className="row">
                        <div className="col-6">
                            <OrdersTable mode="MyOrders" />
                        </div>
                        <div className="col-6">
                            {user && (user.role === "Admin" || user.role === "Director") && (
                                <SalesByRep />
                            )}
                        </div>
                    </div>

                    

                    <div className="row">
                        <div className="col" style={{textAlign:"right"}}><img src={UFASLogo} width="200" /></div>
                    </div>

                    
                </div>
            </div>
        </div>);
}
